import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { RobbieProposalCard } from '../../components/robbie';
import { useRobbieProposal } from '../../hooks/useRobbieProposal';
import { RobbieProposal } from '../../types/robbieProposal';

/** A step card wired to the RFQ in the store: applying re-reads it in place. */
export interface WizardRobbieProposalProps {
  /** The assistant message the proposal belongs to, plus the action's position in it. */
  storageKey: string;
  proposal: RobbieProposal;
  canApply: boolean;
}

export const WizardRobbieProposal: React.FC<WizardRobbieProposalProps> = ({ storageKey, proposal, canApply }) => {
  const rfqId = useSelector((state: RootState) => (state.rfq.rfqData as { rfqId?: string } | null)?.rfqId);
  const state = useRobbieProposal(storageKey, proposal, rfqId);
  return (
    <RobbieProposalCard
      proposal={proposal}
      outcome={state.outcome}
      applying={state.applying}
      error={state.error}
      canApply={canApply}
      onApply={state.apply}
      onDismiss={state.dismiss}
    />
  );
};

export default WizardRobbieProposal;
